import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ErrorPage.css';

const ErrorPage = ({ type = '404', title = null, message = null }) => {
    const navigate = useNavigate();

    // Default configurations for common error codes
    const defaults = {
        '403': {
            title: 'Access Denied',
            message: 'Sorry, you do not have the required permissions to view this page. Please contact your administrator if you believe this is an error.',
            code: '403'
        },
        '404': {
            title: 'Page Not Found',
            message: 'Oops! The page you are looking for does not exist. It might have been moved or deleted.',
            code: '404'
        }
    };

    const content = defaults[type] || defaults['404'];

    // Override message/title if provided via props
    const displayTitle = title || content.title;
    const displayMessage = message || content.message;
    const displayCode = content.code;

    return (
        <div className="error-page-container">
            <div className="error-content">
                <div className="error-code">{displayCode}</div>
                <h1 className="error-title">{displayTitle}</h1>
                <p className="error-message">{displayMessage}</p>
                <div className="error-actions">
                    <button className="error-button" onClick={() => navigate('/home')}>
                        Go to Dashboard
                    </button>
                    {/* Add back button logic if needed */}
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
